import tw from 'twin.macro';
import { useTranslation } from 'react-i18next';

import { useIntegrationsContext } from '@insights_module/context/IntegrationsContext';
import { Spacer } from '@components/Spacer';
import { Button } from '@components/Button';
import { PlusIcon } from '@icons/PlusIcon';
import { FEATURE_FLAG, useFeatureFlag } from '@auth_module/hooks/useFeatureFlag';

const Container = tw.div`block w-[390px] text-center mx-auto my-[100px]`;
const Title = tw.span`text-lg font-bold text-text-and-icon-muted`;
const Description = tw.p`text-sm text-text-and-icon-muted-2 leading-[19.6px]`;
const CreateTagBtn = tw(
  Button.Primary
)`text-[11px] px-3 py-1 w-auto h-auto inline-flex items-center justify-center mt-[8px]`;

const Card = tw.div`bg-page-background hover:bg-gray-2 border border-solid border-gray-1 rounded-[8px] p-[12px] flex flex-col items-center justify-center gap-[12px] min-h-[243px] w-[217px] cursor-pointer`;
const CardTitle = tw.h3`text-text-and-icon whitespace-nowrap text-[14px]`;
const CardDescription = tw.p`text-text-and-icon text-[12px]`;

export const NoTagsFallback = (): JSX.Element => {
  const { t } = useTranslation();
  const { setIsCreateTagModalOpen, layoutType } = useIntegrationsContext();

  const { isEnabled: isIHMStarshipIntegrationEnabled } = useFeatureFlag(
    FEATURE_FLAG.IHM_STARSHIP_INTEGRATION
  );

  return (
    <>
      {layoutType === 'grid' ? (
        <Card onClick={() => setIsCreateTagModalOpen(true)}>
          <PlusIcon tw='stroke-text-and-icon' />
          <CardTitle>{t('insights.integrations.megaphone.no_tags_fallback.card.title')}</CardTitle>
          <CardDescription>
            {t('insights.integrations.megaphone.no_tags_fallback.card.description')}
          </CardDescription>
        </Card>
      ) : (
        <Container data-testid='no-tags-fallback'>
          <Title>{t('insights.integrations.megaphone.no_tags_fallback.title')}</Title>
          <Description>
            {isIHMStarshipIntegrationEnabled
              ? t('insights.integrations.ihm_starship.no_tags_fallback.description')
              : t('insights.integrations.megaphone.no_tags_fallback.description')}
          </Description>
          <Spacer direction='vertical' size='xxs' />
          <CreateTagBtn
            data-testid='create-tag-button'
            onClick={() => setIsCreateTagModalOpen(true)}>
            <PlusIcon tw='stroke-text-and-icon-invert w-4 h-4' />
            {t('insights.integrations.megaphone.no_tags_fallback.cta')}
          </CreateTagBtn>
        </Container>
      )}
    </>
  );
};
